(function()
{
    //Import classes
    var 
        BasePanel = include('springroll.easeljs.BasePanel'),
        Bitmap = include('createjs.Bitmap'),
        DwellTimer = include('springroll.easeljs.DwellTimer'),
        SoundButton = include('springroll.easeljs.SoundButton');

    /**
     *  Panel contains all of the visual elements for the title state
     *  @class sid.TitlePanel
     *  @extends springroll.easeljs.BasePanel
     */
    var TitlePanel = function()
    {
        BasePanel.call(this);
    };

    //Super prototype
    var s = BasePanel.prototype;

    //Extend the base panel
    var p = extend(TitlePanel, BasePanel);

    /**
     *  Setup the state, this happens on each state entering
     */
    p.setup = function()
    {
        this.background = new Bitmap(images.TitleBackground);
        this.addChildAt(this.background, 0);
        this.background.name = 'TitleBackground';
        DwellTimer.create(this.background);

        this.playButton = new SoundButton(images.PlayButton);
        this.playButton.name = "PlayButton";
        DwellTimer.create(this.playButton);
        this.playButton.x = 580;
        this.playButton.y = 355;
        this.playButton.scaleX = this.playButton.scaleY = 1.5;
        this.playButton.name = "play-button";
        this.playButton.mouseEnabled = true;
        this.addChild(this.playButton);

        DwellTimer.create(this.playButton);
    };

    /**
     *  Un-setup the panel when exiting the state
     */
    p.teardown = function()
    {
        s.teardown.call(this);
        this.background = null;
        this.playButton = null;
    };

    //Assign to namespace
    namespace('sid').TitlePanel = TitlePanel;
}());
